import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const PrivacyPolicy = () => {
  // 🔹 Static Privacy Policy Content
  const privacySections = [
    {
      id: 1,
      title: "Introduction",
      description:
        "We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you interact with our website or services.",
      is_active: 1,
    },
    {
      id: 2,
      title: "Information We Collect",
      description:
        "We may collect the following types of information:\n\n• Personal details such as name, email address, phone number.\n• Billing and shipping address for order processing.\n• Payment information (processed securely through trusted payment gateways).\n• Device and browser information for improving website performance.\n• Cookies and tracking data for analytics and personalization.",
      is_active: 1,
    },
    {
      id: 3,
      title: "How We Use Your Information",
      description:
        "Your data is used for the following purposes:\n\n• To process, confirm, and deliver your orders.\n• To communicate status updates or respond to support queries.\n• To improve website performance and customer experience.\n• To prevent fraud, ensure security, and comply with legal requirements.\n• To send promotional updates (only if you opt-in).",
      is_active: 1,
    },
    {
      id: 4,
      title: "How We Protect Your Data",
      description:
        "We implement strong security measures to protect your personal information:\n\n• Encrypted data transmission (SSL).\n• Secure payment gateways.\n• Restricted access to sensitive information.\n• Regular security audits and monitoring.",
      is_active: 1,
    },
    {
      id: 5,
      title: "Sharing of Information",
      description:
        "We do not sell or trade your personal information. However, we may share data with:\n\n• Trusted delivery partners.\n• Payment gateway providers.\n• IT and marketing service providers.\n• Authorities when required by law.\n\nAll third parties are required to follow strict data protection rules.",
      is_active: 1,
    },
    {
      id: 6,
      title: "Cookies Policy",
      description:
        "Our website uses cookies to enhance your shopping experience.\nCookies help us:\n\n• Remember your preferences.\n• Improve website speed and performance.\n• Deliver personalized product recommendations.\n• Track analytics to improve user experience.\n\nYou can disable cookies anytime from your browser settings.",
      is_active: 1,
    },
    {
      id: 7,
      title: "Your Rights",
      description:
        "You have the right to:\n\n• Access your personal information.\n• Request corrections or updates.\n• Request deletion of your data (subject to legal requirements).\n• Opt-out of promotional communications.\n\nTo request these actions, contact our support team.",
      is_active: 1,
    },
    {
      id: 8,
      title: "Changes to This Policy",
      description:
        "We may update our Privacy Policy from time to time. Any changes will be posted on this page with the updated date.",
      is_active: 1,
    },
   
  ];

  return (
    <>
      <div className="py-5 bg-white">
        <Container>
          <Row>
            <Col md={8}>
              {/* <h2 className="mb-4">Privacy Policy</h2> */}

              {privacySections.map((section) => (
                <div key={section.id} className="mb-4 border-bottom">
                  
                  {/* Section Header */}
                  <div className="p-3">
                    <h5 className="mb-2 text-dark fw-bold">{section.title}</h5>

                    {/* {section.is_active === 1 && (
                      <span className="text-success small fw-bold">● Active</span>
                    )} */}
                  </div>

                  {/* Section Content */}
                  <div className="p-3 bg-white border-top">
                    <p
                      className="mb-0"
                      style={{
                        fontSize: "18px",
                        color: "#313131FF",
                        whiteSpace: "pre-line",
                      }}
                    >
                      {section.description}
                    </p>
                  </div>
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      </div>
      <hr />
    </>
  );
};

export default PrivacyPolicy;
